/**
 * Compact address format used across the mobile-web wallet UI:
 * `[6 leading chars]...[4 trailing chars]`, e.g. `0xe38b...D9d7`.
 *
 * Works for any identifier string (EVM `0x…`, RAILGUN `0zk…`, ENS-less raw).
 * Returns the input untouched when it's too short to truncate meaningfully.
 */
const formatShortAddress = (address?: string | null): string => {
  if (!address) return ''
  if (address.length <= 10) return address

  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

export default formatShortAddress
